import Spinner from 'src/components/ui/spinner';
import { useDialog } from 'src/customHooks/useDialog';
import React, { useEffect, useState } from 'react';
import './interactionLayer.scss';

interface InteractionLayerProps {
    apiErrorContent?: any;
    bodyContent?: any;
    footerContent?: any;
    loading?: boolean;
    open?: boolean;
    titleContent?: any;
    updateOpenLayer: (arg: boolean) => void;
}

const InteractionLayer = React.forwardRef(
    (
        {
            apiErrorContent,
            bodyContent,
            footerContent,
            loading,
            open,
            titleContent,
            updateOpenLayer,
        }: InteractionLayerProps,
        ref: any,
    ) => {
        const [interactionLayerOpen, setInteractionLayerOpen] =
            useState<boolean>(false);
        useEffect(() => {
            if (typeof open === 'boolean') setInteractionLayerOpen(open);
        }, [open]);
        const { dialogRef, closeDialogRef, openDialogRef } = useDialog();
        useEffect(() => {
            const openClose = async () => {
                if (interactionLayerOpen) openDialogRef();
                else await closeDialogRef();
            };
            openClose();
        }, [interactionLayerOpen]);
        return (
            <dialog
                ref={dialogRef}
                className='c-interaction-layer js-interaction-layer  c-interaction-layer--modal custom-interaction-layer'
                id='interaction-layer'
            >
                <div className='js-interaction-layer-close' tabIndex={-1}></div>

                <div className='c-interaction-layer__wrapper' role='dialog'>
                    <div className='content-wrapper'>
                        <header className='c-interaction-layer__header'>
                            <button
                                className='c-interaction-layer__close-btn  js-interaction-layer-close  js-interaction-layer-autofocus'
                                type='button'
                                aria-label='Close'
                                onClick={() => {
                                    setInteractionLayerOpen(true);
                                    updateOpenLayer(false);
                                }}
                            ></button>
                            {titleContent ? (
                                <div className='c-modal__title__wrapper'>
                                    <h2
                                        className='c-modal__title'
                                        id='foo-bar-baz'
                                    >
                                        {titleContent}
                                    </h2>
                                </div>
                            ) : null}
                        </header>
                        {apiErrorContent}
                        {loading ? (
                            <div className='spinner-loading'>
                                <Spinner />
                            </div>
                        ) : (
                            <>
                                <div
                                    className='c-interaction-layer__content'
                                    role='document'
                                    ref={ref}
                                >
                                    {bodyContent}
                                </div>
                                {footerContent ? (
                                    <div className='c-drawer__footer'>
                                        {footerContent}
                                    </div>
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            </dialog>
        );
    },
);

InteractionLayer.displayName = 'InteractionLayer';
export default InteractionLayer;
